type Context = 'tech-intelligence';

type Section = 'dataset' | 'filters';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  dataset: 'tech-intelligence-dataset',
  filters: 'tech-intelligence-filters',
};
